import React from "react";
import { Button, Col, Form, Input, Row, Tabs, Typography, message } from "antd";
import { LockOutlined, UserOutlined, SafetyOutlined } from '@ant-design/icons';
import img01 from "../../assets/img/login-img.png";
import { Link } from "react-router-dom";
import BaseComponent from "../../redare/components/BaseComponent";
import LoginPresenter from "../../.gen/presenter/LoginPresenter";
import WebWorkbenchPresenter from "../../.gen/presenter/WebWorkbenchPresenter";

import logo from "../../assets/img/logo.png";
import { Redirect } from "react-router";

const { Title, Paragraph } = Typography;

export default class ChangePasswordPage extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            img: '',
            loading: false,
            loadingTime: undefined
        }
        this.loginPresenter = new LoginPresenter(this);
        this.webWorkbenchPresenter = new WebWorkbenchPresenter(this);
        this.presenter = new WebWorkbenchPresenter(this);
    }

    componentDidMount() {
        let { state } = this.props.location;
        if (state) {
            let user = state.user;
            if (user) {
                this.form.setFieldsValue({ mobile: user.mobile });
            }
        }
        this.getImg();
    }

    _onSubmit() {
        this.form.validateFields(["mobile", "mobileCode", "pwd", "pwd2", "code"]).then(
            values => {
                values.rancode = this.state.img.rancode;
                this.presenter.forgetpwd(values, res => {
                    if (res.code == 0) {
                        message.info("修改成功");
                        this.props.history.push('/login')
                    } else {
                        message.info(res.msg || res.message);
                    }
                });
            }
        );

    }

    getImg() {
        this.presenter.getImg({}, res => {
            if (res.code == 0) {
                this.setState({ img: res.data });
            }
        });
    }
    getPhoneMobile() {
        this.form.validateFields(["mobile",  "pwd", "pwd2"]).then(
            values => {
                this.setState({ loading: true })
                this.form.validateFields(["mobile","code"]).then(
                    values => {
                        if (values.mobile.length != 11) {
                            message.error('请填写正确手机号');
                        } else {
                            values.rancode = this.state.img.rancode;
                            this.presenter.getPhoneMobile(values, res => {
                                if (res.code == 0) {
                                    let tiemr = null;
                                    let nowTimer = 90;
                                    tiemr = setInterval(() => {
                                        console.log(this.state.loadingTime);
                                        this.setState({ loadingTime: nowTimer });
                                        nowTimer--;
                                        if (nowTimer <= 0) {
                                            clearInterval(tiemr);
                                            this.setState({ loading: false });
                                        }
                                    }, 1000);
                                } else {
                                    this.setState({ loading: false });
                                }
                            }, err => {
                                this.setState({ loading: false });
                            });
                        }
                    },
                    err => {
                        this.setState({ loading: false });
                    }
                );
            }
        );
    }
    render() {
        return (
            <div className="Login-Page">
                <div className="login-box bg-white">
                    <div className="pic">
                        <img className="" src={img01} />
                    </div>
                    <div className="con">
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Row justify="center" className="logo">
                                    <Col>
                                        <h1>忘记密码</h1>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Form ref={(o) => this.form = o} className="login-form" >
                                    <Form.Item name="mobile" rules={[{
                                        required: true, validator: (rule, value, callback) => {
                                            if (value && value.length !== 11) {
                                                callback('请输入11位手机号');
                                            } else if (!value || value.length == 0) {
                                                callback('请输入手机号');
                                            } else {
                                                callback();
                                            }
                                        }
                                    }]}
                                        validateTrigger="blue"
                                    >
                                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="手机号" />
                                    </Form.Item>
                                    <Form.Item name="pwd" rules={[{
                                        required: true, validator: (rule, value, callback) => {
                                            const hasNumber = /\d/;
                                            const hasLetter = /[a-zA-Z]/;

                                            let pwd2 = this.form.getFieldValue("pwd2");
                                            if (hasNumber.test(value) && hasLetter.test(value) && value.length >= 8) {
                                                if (value != pwd2) {
                                                    callback('密码不同');
                                                } else {
                                                    callback();
                                                }
                                            } else {
                                                callback('请输入包含数字及字母8位以上密码');
                                            }
                                        }
                                    }]}
                                        validateTrigger="blue">
                                        <Input
                                            prefix={<LockOutlined className="site-form-item-icon" />}
                                            type="password"
                                            placeholder="请设置8位以上新密码!"
                                        />
                                    </Form.Item>
                                    <Form.Item name="pwd2" rules={[{
                                        required: true, validator: (rule, value, callback) => {
                                            const hasNumber = /\d/;
                                            const hasLetter = /[a-zA-Z]/;
                                            let pwd = this.form.getFieldValue("pwd");
                                            if (hasNumber.test(value) && hasLetter.test(value) && value.length >= 8) {
                                                if (value != pwd) {
                                                    callback('密码不同');
                                                } else {
                                                    callback();
                                                }
                                            } else {
                                                callback('请输入包含数字及字母8位以上密码');
                                            }
                                        }
                                    }]}
                                        validateTrigger="blue">
                                        <Input
                                            prefix={<LockOutlined className="site-form-item-icon" />}
                                            type="password"
                                            placeholder="请重复输入密码"
                                        />
                                    </Form.Item>
                                    <Form.Item name="code"
                                        rules={[{ required: true, message: '请输入验证码！' }]}
                                        style={{ width: "calc(100% - 120px)", display: 'inline-block' }}
                                    >
                                        <Input

                                            prefix={<SafetyOutlined className="site-form-item-icon" />}
                                            placeholder="验证码"
                                        />
                                    </Form.Item>
                                    <img
                                        style={{ height: 40, position: "relative", marginLeft: 13 }}
                                        src={'data:image/png;base64,' + this.state.img.image}
                                        onClick={() => {
                                            this.getImg();
                                        }}
                                    />
                                    <Form.Item name="mobileCode"
                                        rules={[{ required: true, message: '请输入验证码！' }]}
                                        style={{ width: "calc(100% - 150px)", display: 'inline-block' }}
                                    >
                                        <Input

                                            prefix={<SafetyOutlined className="site-form-item-icon" />}
                                            placeholder="短信验证码"
                                        />
                                    </Form.Item>
                                    <Button type="primary" className="login-form-button"
                                        onClick={this.getPhoneMobile.bind(this)}
                                        loading={this.state.loading}
                                        style={{ width: 137, marginLeft: 13 }}
                                    >
                                        {
                                            this.state.loading ?
                                                `重新发送${this.state.loadingTime ? '(' + this.state.loadingTime + ')' : ''}`
                                                :
                                                '获取验证码'
                                        }

                                    </Button>
                                    <Button type="primary" style={{ width: '100%' }} className="login-form-button"
                                        onClick={this._onSubmit.bind(this)}
                                    >
                                        确定
                                    </Button>
                                </Form>
                            </Col>
                            <Col span={24}>
                                <div className="text-alignC">
                                    记起密码？<Link to="/login"> 立即登陆</Link>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div >
        )
    }
}
